import { Component, Input } from '@angular/core';
import { OrderReminderNote } from '../../../models/patients/note';

@Component({
	selector: 'app-order-reminder-notes',
	templateUrl: './order-reminder-notes.component.html',
	styleUrl: './order-reminder-notes.component.scss'
})
export class OrderReminderNotesComponent {
	@Input() notes: OrderReminderNote[] = [];

	get hasNotes(): boolean {
		return this.notes.length > 0;
	}

	get sortedNotes(): OrderReminderNote[] {
		return [...this.notes].sort((a, b) => (b.createdAt?.getTime() || 0) - (a.createdAt?.getTime() || 0));
	}

	sourceLabel(note: OrderReminderNote): string {
		return [note.source, note.sourceName].filter(Boolean).join(': ');
	}
}
